export const MONTH_AGO_RESTRICTION = 30
